import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return '—';
  return new Intl.NumberFormat('tr-TR').format(n);
}

/**
 * Format a balance stored as micro-USD (1 unit = $0.000001) as a
 * human-readable dollar amount. Default: 6 decimals so fractional
 * cents (token-level costs) are visible. Pass `decimals` for other
 * views (e.g. 2 for a summary card).
 */
export function formatUsd(microUsd: number | null | undefined, decimals = 6): string {
  if (microUsd == null) return '—';
  const usd = microUsd / 1_000_000;
  return `$${usd.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatDate(unixSeconds: number | null | undefined): string {
  if (!unixSeconds) return '—';
  return new Intl.DateTimeFormat('tr-TR', { dateStyle: 'medium' }).format(new Date(unixSeconds * 1000));
}
